exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3yVhEfGl5YtEA0Nc8PCJ5u{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1rem;font-weight:600;letter-spacing:.03571rem;line-height:1.28571;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:inherit;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.85714rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;text-decoration:none;text-transform:uppercase}._8cG9dDExba2IpFC2x8u1B{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"LessonHomeworkViewerLink": "_3yVhEfGl5YtEA0Nc8PCJ5u",
	"LessonHomeworkViewerLink_icon": "_8cG9dDExba2IpFC2x8u1B"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/StudentApp/style.postcss
// module id = 1631
// module chunks = 0